@use '@lib/assets/styles/main' as *;

.locationPhoto {
  img {
    display: block;
    width: 100%;
  }
}

.conductCodeSections {
  margin-top: 32px;
  border-radius: 6px;
  border: 1px solid $gray100;
  background: $gray0;
  padding: 8px 12px;
  display: grid;
  grid-template-columns: 24px auto min-content;
  grid-column-gap: 12px;
  align-items: center;
}

.conductCodeSectionsIcon {
  color: $gray400;
}

.conductCodeSectionsDate {
  margin-top: 4px;
  color: $gray400;
}

.conductCodeSectionsActions {
  display: flex;
  gap: 16px
}

.conductCodeAddBtn {
  padding-top: 24px;
}
